import React, { useState } from "react";
import ICatalog_ItemUI from "../../../../models/ICatalog_ItemUI";
import SupplierService from "../../../../services/SupplierService";
import ISupplierModel from "../../../../models/ISupplierModel";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import OwButton from "../../../shared/OwButton/OwButton";

type Props = {
    row: ICatalog_ItemUI;
    addItemToCart: (row: ICatalog_ItemUI) => void;
    supplierModel: ISupplierModel;
};

export const InventoryItemAddDetail = (props: Props) => {
    const step = SupplierService.getStep(props.supplierModel);

    const [qty, setQty] = useState(0);

    const handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "qty":
                setQty(value);
                break;
        }
    };

    const addItemToCart = () => {
        const row = { ...props.row };
        row.qty = qty;

        props.addItemToCart(row);
    };

    return (
        <div className={"w-10r input-group"}>
            <OwFnInput
                name={"qty"}
                fn={handleChange}
                value={qty}
                type={"number"}
                min={0}
                step={step}
                disableKeyUp={true}
                noOuterDiv={true}
            />
            {!props.row.addedItem ? (
                <OwButton disabled={!(qty && qty > 0)} title={"add"} leftIconClass={"fas fa-plus"} fn={addItemToCart} />
            ) : (
                <OwButton disabled={false} title={"update"} fn={addItemToCart} />
            )}
        </div>
    );
};
